// extracted by mini-css-extract-plugin
export default {"phoneDiv":"reset-password_phoneDiv__P2zIk","otpDiv":"reset-password_otpDiv__0O98t","passwordDiv":"reset-password_passwordDiv__B5X6m","successDiv":"reset-password_successDiv__T9sJ8"};